module.exports = __webpack_public_path__ + "static/media/fontanero.a955828b.svg";